import { useContext, useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { UserRegisterRepository } from 'interfaceAdapter/repositories/UserRegister';
import { BuyerUserQuery } from 'interfaceAdapter/queries/BuyerUser';

export const useBuyerUserRegistrationAuth = () => {
    const diContainer = useContext(diContainerContext);
    const userRegisterRepository = diContainer.resolve(UserRegisterRepository);
    const buyerUserQuery = diContainer.resolve(BuyerUserQuery);
    const [complete, setComplete] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [authError, setAuthError] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();
    const params = useParams();

    const auth = useCallback(
        async (urlId: string) => {
            if (urlId === '') {
                return;
            }
            const { status } = await buyerUserQuery.checkToken(true);
            if (status !== false) {
                setComplete(true);
                setIsLoggedIn(true);
                return;
            }
            try {
                // あまりいい方法ではないけれど。
                const fromInvite = window.location.href.includes('from_invite');
                await userRegisterRepository.buyerUrlAuth(urlId, fromInvite);
                setComplete(true);
                setShowSnackbar(true);
                if (fromInvite) {
                    setTimeout(
                        () => window.location.replace(`/buyer/registration/password/from_invite/${urlId}`),
                        1500,
                    );
                    return;
                }
                setTimeout(() => window.location.replace(`/buyer/registration/password/${urlId}`), 1500);
            } catch (error) {
                console.error(error);
                setComplete(true);
                setAuthError(true);
            }
        },
        [navigate, userRegisterRepository],
    );

    useEffect(() => {
        if (!params.url_id) {
            return;
        }
        auth(params.url_id);
    }, [params.url_id, auth]);

    return {
        complete,
        authError,
        showSnackbar,
        isLoggedIn,
    };
};
